export enum AysClinicSize {
    SMALL = 1,
    MEDIUM = 2,
    LARGE = 3,
    EXTRA_LARGE = 4
}

export const AYS_CLINIC_SIZE_DISPLAY_NAMES: Record<AysClinicSize, string> = {
  [AysClinicSize.SMALL]: 'Klein (< 100 Betten)',
  [AysClinicSize.MEDIUM]: 'Mittel (100 - 200 Betten)',
  [AysClinicSize.LARGE]: 'Groß (200 - 500 Betten)',
  [AysClinicSize.EXTRA_LARGE]: 'Sehr Groß (> 500 Betten)',
};
